module.exports = __webpack_public_path__ + "static/media/support-line.70cad818.png";